













import { Component, Prop, Vue } from 'vue-property-decorator';

import ChangelogEntryLog from '@/components/dashboard/changelogs/ChangelogEntryLog.vue';
import ChangelogEntryCategory from '@/components/dashboard/changelogs/ChangelogEntryCategory.vue';
import { ChangelogEntryViewObject } from '@/types/apiServerContract';

@Component({
    components: { ChangelogEntryLog, ChangelogEntryCategory }
})
export default class ChangelogEntry extends Vue {
	@Prop({ type: Array }) entries!: ChangelogEntryViewObject[];
	@Prop({ type: Number, default: 0 }) nestedIndex!: number;
	@Prop({ required: false, type: String, default: 'div' }) tag!: string;

	get style() {
	    return `margin-left: ${this.nestedIndex * 15}px;`;
	}
}
